<template>
  <div class="service-list">
    <vice-title>
      <h3>服务案例</h3>
    </vice-title>
    <ul class="list">
      <li
        class="item"
        v-for="item of list"
        :key="item.id"
        @click="handleItemClick(item)"
      >
        <div class="item-img">
          <img :src="item.img" alt="" />
        </div>
        <div class="item-content">
          <h3 class="title">{{ item.title }}</h3>
          <p class="line"></p>
          <p class="synopsis">
            <span class="inner">案例简介：</span>
            {{ item.abstract }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ViceTitle from "../../components/ViceTitle";
export default {
  name: "ServiceCase",
  components: {
    ViceTitle
  },
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleItemClick(row) {
      this.$router.push({
        path: "/NewsDetail",
        query: {
          id: row.id
        }
      });
    },
    getList() {
      this.$http
        .post("api/news/list", {
        // .post("http://api.chunhuahealth.com/api/news/list", {
          is_news: 6
        })
        .then(res => {
          console.log(res);
          this.list = res.data.data.data;
        })
        .catch();
    }
  }
};
</script>

<style lang="scss" scoped>
.service-list {
  width: 75%;
  margin: 0 auto;
  .list {
    .item {
      cursor: pointer;
      height: 180px;
      display: flex;
      margin-bottom: 20px;
      .item-img {
        width: 30%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item-content {
        width: 70%;
        padding: 20px 50px 20px 20px;

        .title {
          color: #3b3b3b;
          font-size: 18px;
        }
        .line {
          width: 100%;
          border-bottom: 1px solid #d4d4d4;
          margin: 15px 0;
        }
        .synopsis {
          margin-top: 20px;
          color: #a3a3a3;
          font-size: 16px;
          line-height: 22px;
          .inner {
            color: #3a3a3a;
          }
        }
      }
    }
  }
}
</style>
